export const CATEGORIES = [
  { id: 'financieel', name: 'Financieel & Belasting' },
  { id: 'contracten', name: 'Contracten & Huur' },
  { id: 'leveranciers', name: 'Leveranciers & Inkoop' },
  { id: 'techniek', name: 'Techniek & Apparatuur' },
  { id: 'voertuigen', name: 'Voertuigen' },
  { id: 'vastgoed', name: 'Vastgoed & Facilitair' },
  { id: 'veiligheid', name: 'Veiligheid & Compliance' },
  { id: 'milieu', name: 'Milieu & Infrastructuur' },
  { id: 'nieuwbouw', name: 'Nieuwbouw & Verbouwing' },
  { id: 'overnames', name: 'Overnames' },
  { id: 'automatisering', name: 'Automatisering' },
];

export const STATUS_OPTIONS = [
  { id: 'active', name: 'Actief' },
  { id: 'pending', name: 'In Behandeling' },
  { id: 'pending_review', name: 'Te Beoordelen' },
  { id: 'archived', name: 'Gearchiveerd' },
];

export const BV_OPTIONS = [
  { id: 'truckwash', name: 'Truckwash' },
  { id: 'truckshop', name: 'Truckshop 1' },
  { id: 'truckstop', name: 'Truckstop 8' },
  { id: 'truckssupply', name: 'Truckssupply' },
  { id: 'techniek', name: 'Techniek & Beheer' },
  { id: 'holding', name: 'MT / Holding' },
];

export const CATEGORY_MAP = {};
CATEGORIES.forEach(c => { CATEGORY_MAP[c.id] = c.name; });

export const DOC_TYPE_BADGE = {
  huurovereenkomst: 'Huurovereenkomst',
  contract: 'Contract',
  keuring: 'Keuringsrapport',
  factuur: 'Factuur',
  vergunning: 'Vergunning',
  offerte: 'Offerte',
  overig: 'Document',
};

export const STATUS_CLASSES = { active: 'badge-active', pending: 'badge-pending', pending_review: 'badge-pending', archived: 'badge-archived' };
export const STATUS_LABELS = { active: 'Actief', pending: 'Concept', pending_review: 'Te Beoordelen', archived: 'Gearchiveerd' };

export function cleanTitle(title) {
  return (title || '').replace(/^(FW|RE|Fwd|Betr|AW):\s*/gi, '');
}

export function keyDataSummary(keyData) {
  if (!keyData || typeof keyData !== 'object') return null;
  const parts = [];
  const fin = keyData.financials;
  if (fin?.amount) parts.push(fin.amount.replace('EUR ', '\u20AC'));
  else if (fin?.monthly) parts.push(fin.monthly.replace('EUR ', '\u20AC') + '/mnd');
  const dates = keyData.dates;
  if (dates?.end) {
    try { parts.push('tot ' + new Date(dates.end).getFullYear()); } catch {}
  }
  const parties = keyData.parties;
  if (parties?.verhuurder) {
    const name = parties.verhuurder.split(',')[0].split('KvK')[0].trim();
    if (name.length <= 25) parts.push(name);
  } else if (parties?.leverancier) {
    const name = parties.leverancier.split(',')[0].trim();
    if (name.length <= 25) parts.push(name);
  }
  return parts.length > 0 ? parts.join(' \u00B7 ') : null;
}

export function stripHtml(html) {
  if (!html) return '';
  return html.replace(/<[^>]*>/g, '').substring(0, 150);
}

export function formatDate(dateStr) {
  if (!dateStr) return '';
  try {
    return new Date(dateStr).toLocaleDateString('nl-NL', { day: 'numeric', month: 'short', year: 'numeric' });
  } catch { return ''; }
}

export const levenshtein = (a, b) => {
  if (a.length === 0) return b.length;
  if (b.length === 0) return a.length;
  const matrix = [];
  for (let i = 0; i <= b.length; i++) matrix[i] = [i];
  for (let j = 0; j <= a.length; j++) matrix[0][j] = j;
  for (let i = 1; i <= b.length; i++) {
    for (let j = 1; j <= a.length; j++) {
      if (b.charAt(i - 1) === a.charAt(j - 1)) {
        matrix[i][j] = matrix[i - 1][j - 1];
      } else {
        matrix[i][j] = Math.min(
          matrix[i - 1][j - 1] + 1,
          matrix[i][j - 1] + 1,
          matrix[i - 1][j] + 1
        );
      }
    }
  }
  return matrix[b.length][a.length];
};
